export function sameIds(a: string[], b: string[]) {
  if (a.length !== b.length) return false;
  const set = new Set(b);
  return a.every((id) => set.has(id));
}

type FertEmbryos = {
  liveEmbryos?: { id?: string | null }[] | null;
  tempEmbryos?: { embryoFreezeEntryId?: string | null }[] | null;
};

/**
 * Mating ids that should stay selected after "Unselect All Temp/Live".
 *
 * A mating is dropped when it owns embryos of the cleared kind and none of its
 * remaining (other-kind) embryos are still selected. Matings with no embryos
 * of the cleared kind are left alone, since the user may have checked them
 * directly. Same rule as useFertRowSelection.
 */
export function fertIdsAfterClear(
  kind: 'temp' | 'live',
  fertIds: string[],
  embryosByFert: Map<string, FertEmbryos>,
  remainingSelectedIds: string[],
): string[] {
  const remaining = new Set(remainingSelectedIds);
  return fertIds.filter((fertId) => {
    const data = embryosByFert.get(fertId);
    if (!data) return true;
    const cleared =
      kind === 'temp'
        ? (data.tempEmbryos ?? []).map((e) => e.embryoFreezeEntryId)
        : (data.liveEmbryos ?? []).map((e) => e.id);
    if (!cleared.some((id) => !!id)) return true;
    const others =
      kind === 'temp'
        ? (data.liveEmbryos ?? []).map((e) => e.id)
        : (data.tempEmbryos ?? []).map((e) => e.embryoFreezeEntryId);
    return others.some((id) => !!id && remaining.has(id));
  });
}
